import { graphql } from '@/gql';
import type { UnmarkRideFromDoNotChargeMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const unmarkRideFromDoNotCharge = async ({ description, rideId, requestId }: UnmarkRideFromDoNotChargeMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      description,
      rideId,
      requestId,
    },
    mutation: graphql(`
      mutation UnmarkRideFromDoNotCharge($description: String, $rideId: String, $requestId: String) {
        unmarkRideFromDoNotCharge(description: $description, rideId: $rideId, requestId: $requestId) {
          id
        }
      }
    `),
  });

  return response.data?.unmarkRideFromDoNotCharge;
};
